export const buttomDate = 'YYYY年M月D日'


// WEBPACK FOOTER //
// src/routes/exportPDF/exportPDFConfig.js